export const breakpoints = {
  tablet: '768px',
  desktop: '1200px',
  desktopLarge: '1632px',
  desktopXLarge: '2248px',
} as const;
